import { CardActions, CardContent, TextField, styled } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import useUserActions from "../hooks/UserActions";

const CustomTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  height: "56px",
}));

export default function Login(props) {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();
  const [userLogin] = useUserActions();

  const onsubmit = (data) => {
    userLogin(data.email, data.password).catch((error) => {
      setError("root.serverError", {
        type: "server",
        message: "ログインに失敗しました",
      });
    });
  };
  const onerror = (err) => console.log(err);

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onsubmit, onerror)}
      noValidate
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "0px",
          width: "552px",
          maxWidth: "90vw",
          height: "306px",
          backgroundColor: "common.white.main",
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "16px",
            gap: "16px",
            width: "100%",
            height: "254px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginBottom: "16px",
              gap: "24px",
              width: "100%",
              height: "128px",
            }}
          >
            <CustomTextField
              id="email"
              label="メール"
              variant="outlined"
              size="medium"
              {...register("email", {
                required: "メールは必須です",
              })}
              error={"email" in errors}
              helperText={errors.email?.message}
            />
            <CustomTextField
              id="password"
              label="パスワード"
              variant="outlined"
              size="medium"
              type="password"
              {...register("password", {
                required: "パスワードは必須です",
              })}
              error={"password" in errors}
              helperText={errors.password?.message}
            />
          </Box>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            size="large"
            sx={{
              alignItems: "center",
              padding: "8px 22px",
              width: "100%",
              height: "42px",
              marginTop: "10px",
            }}
          >
            ログイン
          </Button>
        </CardContent>
        {errors.root?.serverError && (
          <Typography
            variant="body2"
            sx={{
              color: "error.main",
              margin: "-10px 0",
            }}
          >
            {errors.root.serverError?.message}
          </Typography>
        )}
      </Container>
      <CardActions
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          padding: "0px",
          gap: "8px",
          width: "552px",
          maxWidth: "90vw",
          height: "20px",
        }}
      >
        <Link
          href="/password_reset_mail"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "0px",
            width: "184px",
            height: "20px",
            marginTop: "10px",
          }}
        >
          <Typography variant="body2">パスワードをお忘れですか？</Typography>
        </Link>
      </CardActions>
    </Box>
  );
}
